import { render } from "./organizations.vue?vue&type=template&id=0e304f08&ts=true"
import script from "./Organizations.ts?vue&type=script&lang=ts&external"
export * from "./Organizations.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__